<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6">
        <v-card flat color="transparent" height="160px">
          <v-card-text>Contact details</v-card-text>
          <v-divider></v-divider>
          <v-card-title>
          iplaccred@dnanetworks.in
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat color="transparent" height="160px">
          <v-card-text>Application Deadline</v-card-text>
          <v-divider></v-divider>
          <div class="text-center mt-4">
            <Countdown deadline="2020-10-28 12:20:00"></Countdown>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-card height="300px">
          <v-card-text>Forms Assigned</v-card-text>
          <v-divider></v-divider>
        <Assigned></Assigned>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card height="300px">
          <v-card-text>Forms Submitted</v-card-text>
          <v-divider></v-divider>
          <Submitted></Submitted>
        </v-card>
      </v-col>
      
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-card height="330px">
          <v-card-text>Venue</v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card height="330px">
          <v-card-text>How to fill a form?</v-card-text>
          <v-divider></v-divider>
          <v-card-text class="py-0">
            <Howtoapply></Howtoapply>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Countdown from "../../components/user/dashboard/countdown";
import Howtoapply from "../../components/user/dashboard/howtoapply";
import Assigned from "../../components/user/dashboard/assigned";
import Submitted from "../../components/user/dashboard/submitted";

export default {
  components: { Countdown, Howtoapply, Assigned, Submitted },
  mounted() {
    this.$store.commit("setPageTitle", "Dashboard");
  },
};
</script>

<style>
</style>